import type { IGatsbyImageData } from 'gatsby-plugin-image';
import Buttons from '@klv/molecules/buttons';
import FadeInUp from '@klv/utils/fade-in-up';
import Image from '@klv/atoms/image';

import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/fullColumnImageCta.module.scss';

import type { IFullColumnImageCta } from './types';
import Typography from '@klv/atoms/typography';

export const FullColumnImageCta = ({ 
  gradientHeadline,
  image,
  buttons,
  backgroundColor,
  customPadding = { customPaddingBottom: 'default', customPaddingTop: 'default' },
}: IFullColumnImageCta) => {
  return (
    <div className={generateClassName([
      s.styledWrapper,
      s[backgroundColor],
      `${customPadding.customPaddingBottom}PaddingBottom`,
      `${customPadding.customPaddingTop}PaddingTop`,
    ])}
    >
      <div className='grid'>
        <FadeInUp className={s.fadeInUpGrid}>
          {gradientHeadline?.headline && (
            <Typography
              className={s.title}
              as='h2'
              variant='h2'
              dangerouslySetInnerHTML={{ __html: gradientHeadline.headline }}
            />
          )}
        </FadeInUp>
        <FadeInUp className={s.fadeInUpGrid}>
          {image && (
            <Image
              className={s.fullColumnImageCtaImage}
              altText={image?.altText}
              imageData={image?.gatsbyImage as IGatsbyImageData}
            />)}
        </FadeInUp> 
        <FadeInUp className={s.fadeInUpGrid}>
        {buttons && ( 
          <div className={s.integrationCtaWrapper}>
            <Buttons
              buttonColor={backgroundColor === 'dark' ? 'light' : 'dark'}
              variants={['ghost']}
              buttons={buttons}
            /> 
          </div>
        )}
        </FadeInUp>
      </div>
    </div>
  );
};
